import { render } from "./ValueAddRegForm.vue?vue&type=template&id=1fe2fd0c&scoped=true"
import script from "./ValueAddRegForm.vue?vue&type=script&lang=js"
export * from "./ValueAddRegForm.vue?vue&type=script&lang=js"

import "./ValueAddRegForm.vue?vue&type=style&index=0&id=1fe2fd0c&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe2fd0c"]])

export default __exports__